import './Inbox.css';
import { Tooltip } from 'react-tooltip';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import InboxSidebar from './InboxSidebar';
import {
    BrowserRouter,
    Routes,
    Route
} from "react-router-dom";
import InboxGeneral from './InboxGeneral';
import { useEffect, useState } from 'react';
import InboxEmailDetail from './InboxEmailDetail';
import InboxCompose from './InboxCompose';
import { InboxComposeProvider } from './InboxComposeProvider';
import InboxSearch from './InboxSearch';
import InboxService from '../Services/InboxService';


function Inbox() {

    const navigate = useNavigate();

    let [search, setSearch] = useState('');
    const location = useLocation();
    let params = new URLSearchParams(location.search);
    let localSearch = params.toString();

    const [emails, setEmails] = useState([]);
    const [page, setPage] = useState(1);
    const [count, setCount] = useState(0);
    const [selectedAccount, setSelectedAccount] = useState('');
    const [selectedTag, setSelectedTag] = useState('');
    const [read, setRead] = useState('');
    const [lastMessageFromAccount, setLastMessageFromAccount] = useState('');
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        getThreadsForInbox();
    }, []);


    async function getReadFromQueryParams() {
        let params = new URLSearchParams(location.search);
        let read = params.get('read') || '';
        setRead(read);
    }

    async function getTagFromQueryParams() {
        let params = new URLSearchParams(location.search);
        let tag = params.get('tag') || '';
        setSelectedTag(tag);
    }

    function getLastMessageFromAccountFromQueryParams() {
        let params = new URLSearchParams(location.search);
        let fromAccount = params.get('last_message_from_account') || '';
        setLastMessageFromAccount(fromAccount);
    }

    function getAccountFromQueryParams() {
        let params = new URLSearchParams(location.search);
        let account = params.get('account');
        setSelectedAccount(account || '');
    }

    useEffect(() => {
        getThreadsForInbox();
    }, [selectedAccount, selectedTag, read, lastMessageFromAccount]);

    useEffect(() => {
        getAccountFromQueryParams();
        getTagFromQueryParams();
        getReadFromQueryParams();
        getLastMessageFromAccountFromQueryParams();
    }, [location.search])

    useEffect(() => {
        getThreadsForInbox();
    }, [page]);

    async function getThreadsForInbox() {
        setLoading(true);
        let emails = await InboxService.getThreadMessagesForInbox(
            page,
            search,
            selectedAccount,
            selectedTag,
            read,
            lastMessageFromAccount
        );
        setLoading(false);
        setEmails(emails);
    }

    function onPrevEmail(thread_id) {
        let prevEmail = emails.findIndex(email => email.thread_id === thread_id);
        if (prevEmail !== -1) {
            prevEmail = emails[prevEmail - 1];
            if (!prevEmail) {
                return;
            }
            navigate(`/admin/inbox/${prevEmail.thread_id}?${localSearch}`);
        } else {
            navigate(`/admin/inbox?${localSearch}`);
        }
    }

    function onNextEmail(thread_id) {

        let nextEmail = emails.findIndex(email => email.thread_id === thread_id);
        if (nextEmail !== -1) {
            nextEmail = emails[nextEmail + 1];
            if (!nextEmail) {
                return;
            }
            navigate(`/admin/inbox/${nextEmail.thread_id}?${localSearch}`);
        } else {
            navigate(`/admin/inbox?${localSearch}`);
        }
    }


    function onPressEnterKeyInSearch(e) {
        if (e.key === 'Enter') {
            
            getThreadsForInbox();

        }
    }


    return (
        <div className="bg-gray vh-100">
            <InboxComposeProvider>
                <div className="container-fluid px-4">

                    <div className="inbox-container">

                        <InboxSidebar />


                        <div className="inbox-content">

                            <div className="inbox-search-container">
                                <i className="fa-solid fa-magnifying-glass me-2"></i>
                                <input type="text"
                                    onKeyDown={onPressEnterKeyInSearch}
                                    value={search}
                                    onChange={e => setSearch(e.target.value)}
                                    className="inbox-search-bar"
                                    placeholder="search in mail" />

                                <i class="fa-solid fa-filter"></i>
                            </div>

                            <Routes>
                                <Route path="/" element={
                                    <InboxGeneral
                                        loading={loading}
                                        page={page}
                                        setPage={setPage}
                                        emails={emails}
                                    />} />
                                <Route path="/search/:search" element={<InboxSearch />} />
                                <Route path="/:id" element={
                                    <InboxEmailDetail
                                        onPrevEmail={onPrevEmail}
                                        onNextEmail={onNextEmail}
                                        onRefresh={getThreadsForInbox}
                                    />} />

                            </Routes>

                        </div>

                    </div>

                    <InboxCompose />
                </div>

            </InboxComposeProvider>



            <Tooltip id="inbox-tooltip" />
        </div >
    )

}

export default Inbox;
